<msf-summary-wrapper
  title="Main menu"
  leftSize="9"
  rightSize="3"
  [items]="items"
  [separator]="false"
>
  <div right #right [style.height]="'100%'">
    <div class="task-content">

      <div class="flex flex-row align-items-center align-content-center gap-1">
        <img class="align-self-start" [style.margin-top]="'4px'"
             src="/assets/icons/main/light/ico-user-task.svg"
             alt="user-task">
        <h2>{{ 'Tasks of users' | translate }}</h2>
      </div>

      <main-status-tag
        [label]="'Active'"
        [iconSvgPath]="'progress'"
        [color]="'info'"
        [title]="'Title of user task №1' | translate"
        [description]="'Measure the condition of the soil' | translate"
        [date]="'24.05.2024'"
        [time]="'13:32'"
      ></main-status-tag>

      <main-status-tag
        [label]="'Completed'"
        [iconSvgPath]="'lead'"
        [color]="'success'"
        [title]="'Title of user task №2' | translate"
        [description]="'Determine the amount of equipment on site' | translate"
        [date]="'24.05.2024'"
        [time]="'13:32'"
      ></main-status-tag>

      <main-status-tag
        [label]="'Postponed'"
        [iconSvgPath]="'progress-red'"
        [color]="'danger'"
        [title]="'Title of user task №3' | translate"
        [description]="'Determine the amount of equipment on site' | translate"
        [date]="'24.05.2024'"
        [time]="'13:32'"
      ></main-status-tag>

      <div class="flex justify-content-end align-items-center mt-2 all-news-link" style="cursor: pointer">
        <span class="mr-1">{{ 'All' | translate }}</span>
        <img [src]="getIconPath('side-menu-trigger-off')" alt="all news" width="28" height="28">
      </div>

      <p-divider layout="horizontal"></p-divider>

      <div class="flex flex-row align-items-center align-content-center gap-1 mt-3">
        <img class="align-self-start" [style.margin-top]="'4px'"
             src="assets/icons/main/light/ico-news.svg"
             alt="news-icon">
        <h2>{{ 'News' | translate }}</h2>
      </div>

      <app-news
        [title]="'Farmers in country to be protected from risks' | translate:{country: (environment.country | translate)}"
        [date]="'11.20.2024'"
        [time]="'13:48'"
      />
      <app-news
        [title]="'The final stage of the Ministry of Agriculture scholarship program has been completed' | translate"
        [date]="'09.09.2023'"
        [time]="'16:08'"
      />


      <div class="flex justify-content-end align-items-center mt-2 all-news-link" style="cursor: pointer">
        <span class="mr-1">{{ 'All' | translate }}</span>
        <img [src]="getIconPath('side-menu-trigger-off')" alt="all news" width="28" height="28">
      </div>
    </div>
  </div>

</msf-summary-wrapper>
